import React, { ReactNode } from "react";
import AppointmentCancelProvider, {
  useAppointmentCancel,
} from "../AppointmentCancel/AppointmentCancelProvider";
import AppointmentDeleteProvider, {
  useAppointmentDelete,
} from "../AppointmentDelete/AppointmentDeleteProvider";
import AppointmentChangeExpirationProvider, {
  useAppointmentChangeExpiration,
} from "../AppointmentChangeExpiration/AppointmentChangeExpirationProvider";
import AppointmentChangeStaffProvider, {
  useAppointmentChangeStaff,
} from "../AppointmentChangeStaff/AppointmentChangeStaffProvider";
import AppointmentRescheduleProvider, {
  useAppointmentReschedule,
} from "../AppointmentReschedule/AppointmentRescheduleProvider";
import AppointmentCheckInProvider, {
  useAppointmentCheckIn,
} from "../AppointmentCheckIn/AppointmentCheckInProvider";
import AppointmentNoShowProvider, {
  useAppointmentNoShow,
} from "../AppointmentNoShow/AppointmentNoShowProvider";
import AppointmentInfoProvider, {
  useAppointmentInfo,
} from "../AppointmentInfo/AppointmentInfoProvider";
import AppointmentScheduleProvider, {
  useAppointmentScheduleModal,
} from "../AppointmentScheduleModal/AppointmentScheduleProvider";
import BookAppointmentProvider, {
  useBookAppointment,
} from "../BookAppointmentDrawer/BookAppointmentProvider";
import CreditsModalProvider, {
  useCreditsModal,
} from "../CreditsModal/CreditsModalProvider";
import AppointmentApplyCreditProvider, {
  useAppointmentApplyCredit,
} from "../AppointmentApplyCredit/AppointmentApplyCreditProvider";
import AppointmentForgiveScheduleProvider, {
  useAppointmentForgiveSchedule,
} from "../AppointmentForgiveSchedule/AppointmentForgiveScheduleProvider";

interface AppointmentsProviderProps {
  children?: ReactNode;
}

function AppointmentsProvider(props: AppointmentsProviderProps) {
  const { children } = props;
  return (
    <BookAppointmentProvider>
      <AppointmentCancelProvider>
        <AppointmentDeleteProvider>
          <AppointmentRescheduleProvider>
            <AppointmentChangeExpirationProvider>
              <AppointmentChangeStaffProvider>
                <AppointmentCheckInProvider>
                  <AppointmentNoShowProvider>
                    <AppointmentInfoProvider>
                      <CreditsModalProvider>
                        <AppointmentApplyCreditProvider>
                          <AppointmentForgiveScheduleProvider>
                            <AppointmentScheduleProvider>
                              {children}
                            </AppointmentScheduleProvider>
                          </AppointmentForgiveScheduleProvider>
                        </AppointmentApplyCreditProvider>
                      </CreditsModalProvider>
                    </AppointmentInfoProvider>
                  </AppointmentNoShowProvider>
                </AppointmentCheckInProvider>
              </AppointmentChangeStaffProvider>
            </AppointmentChangeExpirationProvider>
          </AppointmentRescheduleProvider>
        </AppointmentDeleteProvider>
      </AppointmentCancelProvider>
    </BookAppointmentProvider>
  );
}

export function useAppointments() {
  const cancelResult = useAppointmentCancel();
  const deleteResult = useAppointmentDelete();
  const rescheduleResult = useAppointmentReschedule();
  const changeExpirationResult = useAppointmentChangeExpiration();
  const changeStaffResult = useAppointmentChangeStaff();
  const checkingResult = useAppointmentCheckIn();
  const noShowResult = useAppointmentNoShow();
  const infoResult = useAppointmentInfo();
  const scheduleResult = useAppointmentScheduleModal();
  const bookResult = useBookAppointment();
  const creditsResult = useCreditsModal();
  const applyCreditsResult = useAppointmentApplyCredit();
  const forgiveScheduleResult = useAppointmentForgiveSchedule();
  return {
    ...cancelResult,
    ...deleteResult,
    ...rescheduleResult,
    ...changeExpirationResult,
    ...changeStaffResult,
    ...checkingResult,
    ...noShowResult,
    ...infoResult,
    ...scheduleResult,
    ...bookResult,
    ...creditsResult,
    ...applyCreditsResult,
    ...forgiveScheduleResult,
  };
}

export default AppointmentsProvider;
